import { render, staticRenderFns } from "./PrestaoresNaoOperadoraDownload.vue?vue&type=template&id=6ea040a8"
import script from "./PrestaoresNaoOperadoraDownload.vue?vue&type=script&lang=js"
export * from "./PrestaoresNaoOperadoraDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports